import React, { FunctionComponent } from "react"

const HRRReportsTableHeader: FunctionComponent<{}> = () => {
    return (
        <thead>
            <tr>
                <th>Name</th>
                <th>Properties</th>
                <th>Filters</th>
            </tr>
        </thead>
    )
}

export default HRRReportsTableHeader